if (!customElements.get('v14-fight-calendar')) {
  class V14FightCalendar extends HTMLElement {
    connectedCallback() {
      this.initReveal();
      this.updateCountdowns();
      this.timer = window.setInterval(() => this.updateCountdowns(), 60000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      if (this.revealObserver) this.revealObserver.disconnect();
    }

    initReveal() {
      const items = [...this.querySelectorAll('[data-v13-reveal]')];
      if (!items.length) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }
      this.classList.add('ff-v14-motion-ready');
      this.revealObserver = new IntersectionObserver((entries, current) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          current.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
      items.forEach((item) => this.revealObserver.observe(item));
    }

    updateCountdowns() {
      const now = Date.now();
      const hidePast = this.dataset.hidePast === 'true';
      const expiredLabel = this.dataset.expiredLabel || 'Event started';

      this.querySelectorAll('[data-fight]').forEach((fight) => {
        const source = fight.dataset.startsAt;
        if (!source) return;
        const startsAt = Date.parse(source);
        if (Number.isNaN(startsAt)) return;

        const remaining = startsAt - now;
        const countdown = fight.querySelector('[data-countdown]');
        if (remaining <= 0) {
          fight.classList.add('is-past');
          if (countdown) {
            countdown.hidden = hidePast;
            countdown.textContent = expiredLabel;
          }
          return;
        }

        fight.classList.remove('is-past');
        if (!countdown) return;
        const totalMinutes = Math.floor(remaining / 60000);
        const days = Math.floor(totalMinutes / 1440);
        const hours = Math.floor((totalMinutes % 1440) / 60);
        const minutes = totalMinutes % 60;
        const parts = [];
        if (days) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
        parts.push(`${hours} ${hours === 1 ? 'hour' : 'hours'}`);
        if (days < 2) parts.push(`${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`);
        countdown.textContent = parts.join(', ');
        countdown.hidden = false;
      });
    }
  }

  customElements.define('v14-fight-calendar', V14FightCalendar);
}
